/**
 * Download a Blob object as a file with the specified filename.
 * @param blob The Blob object to be downloaded.
 * @param filename The desired filename for the downloaded file.
 */
export function downloadBlobAsFile(blob: Blob, filename: string) {
  const link = document.createElement('a');
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
